import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { paths } from '@/routes/paths';

/** Logout goes through the /logout route, which ends the session (see LogoutRoute). */
export function useLogout(): () => void {
  const navigate = useNavigate();
  return useCallback(() => void navigate(paths.logout, { replace: true }), [navigate]);
}
